import { TThunkAction } from '../../types/redux';
import { addAnswer } from '../../services/answers/addAnswer';
import { setNewAnswerFormStep } from './stepActionsTypes';
import { ENewAnswerModalStep } from '../../types/newAnswer';
import { trackNewAnswerSubmit } from '../../analytics/newAnswer';
import { TAnswerTarget } from '../../types/answers';
import { getObjectRating } from '../../selectors/objectInfo';
import { getIsAnonymous, getName } from '../../selectors/newAnswer';
import { getFirstName } from '../../selectors/user';

export function addAnswerActions({
  reviewId,
  type,
}: {
  reviewId: string;
  type: TAnswerTarget;
}): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    try {
      const { httpApi, custom } = context;
      const state = getState();

      await addAnswer({
        httpApi,
        parameters: { reviewId, newAnswer: state.newAnswer },
      });

      const rating = getObjectRating(state);
      const isAnonymous = getIsAnonymous(state);
      const isNameEntered = !!getName(state) || !!getFirstName(state);

      const page = {
        offerType: 'JK',
        pageType: 'ReviewsJK',
        siteType: custom.deviceType,
        extra: {
          review_id: reviewId,
          rating,
          type,
          is_anonymous: isAnonymous,
          is_name_entered: isNameEntered,
        },
      };

      trackNewAnswerSubmit(page);
      dispatch(setNewAnswerFormStep(ENewAnswerModalStep.Success));
    } catch (e) {
      dispatch(setNewAnswerFormStep(ENewAnswerModalStep.Error));
    }
  };
}
